import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgChallenge = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 6.5a1 1 0 0 1-.553.894L16 9.618v2.81L20.6 19h.4a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h.445l4.244-5.877a1 1 0 0 1 1.622 0l2.134 2.955L14 12.428V4a.996.996 0 0 1 .997-1h.011c.165.001.32.043.457.115l4.982 2.49A1 1 0 0 1 21 6.5Zm-6 7.988L18.159 19H11.84L15 14.488ZM9.4 19l.831-1.187-1.73-2.397L5.91 19H9.4ZM16 5.618v1.764l1.764-.882L16 5.618Z", fill: color }));
};
export default factorySvgIcon(SvgChallenge);
//# sourceMappingURL=SvgChallenge.js.map